import React, { PropsWithChildren, useEffect } from 'react'
import { ITabContext, withTabContext } from './TabContext'

interface Props extends ITabContext {
  value: string
  label: string
  count?: number
  hidden?: boolean
  keepTabsInView?: boolean
}

function Tab(props: PropsWithChildren<Props>) {
  const { addTab, updateTab, activeTab, value, label, count, hidden, keepTabsInView, children } =
    props

  useEffect(() => {
    addTab({ value, label })
  }, [])

  useEffect(() => {
    updateTab(value, { label, count, hidden })
  }, [label, count, value, updateTab, hidden])

  const isActive = value === activeTab && !hidden

  // If keepTabsInView is true, keep all tabs mounted but hide inactive ones
  // This allows form validation to work across all tabs
  if (keepTabsInView) {
    return <div style={{ display: isActive ? 'block' : 'none' }}>{children}</div>
  }

  // Default behavior: unmount inactive tabs
  if (!isActive) {
    return null
  }

  return children
}

export default withTabContext(Tab)
